import React from 'react';
import { Page } from '/imports/ui/Page';
import { environments } from '/imports/utils';

const EnvironmentPageStyled = (props: React.ComponentProps<typeof Page>) => (
  <Page
    {...props}
    className={[
      props.className ?? '',
      'p-4',
      '[&_a]:my-8 [&_a]:block',
    ].join(' ')}
  />
);

export const EnvironmentPage = () => {
  return (
    <EnvironmentPageStyled>
      <h1>Switch Environment</h1>
      <a href={environments.production}>Production</a>
      <a href={environments.staging}>Staging</a>
      <a href={environments.development}>Development</a>
    </EnvironmentPageStyled>
  );
};
